import React, { useEffect, useState } from "react";
import { Checkbox, Button, Grid, Paper, Table, TableBody, TableCell, TableHead, TableRow, Tooltip, } from "@material-ui/core";
import { useSnackbar } from "notistack";
import { withRouter } from 'react-router';
import { PageLoader,STableLoader, Pagination, EmptyCollection, DeletePopUp } from "../../shared_elements";
import LinkingPopup from "../../shared_elements/LinkingPopup";
import { checkApiStatus } from "../../utils_v2";
import { globalGetService , globalPostService} from "../../../globalServices";
import { trackActivity } from "../../../utils/mixpanel";
import { assetTypeValues, displayDateFormat } from "../../../constants";
import { numberWithCommas } from "../../../utils";
import moment from "moment";
import { DeleteOutline } from '@material-ui/icons';
import { usePageTitleOffset } from '../../elements/CollapsibleSideNav';

const SvEventsHeader = ({toggleBulkOps, item, bulkUnlink }) => {
    return (
        <TableHead>
            <TableRow >
                <TableCell style={{ position: 'sticky', left: 0, backgroundColor: '#B5BEDB', zIndex: 10, }} ><Checkbox checked={item?.length === bulkUnlink?.ids?.length && item?.length > 0} onChange={(e) => toggleBulkOps(e.target.checked, 'bulk', item)} color="primary" size="small" />Action(s)</TableCell> 
                <TableCell > Name </TableCell>
                <TableCell > Asset Type </TableCell>
                <TableCell > Hours </TableCell>
                <TableCell > Cycles </TableCell>
                <TableCell > Months </TableCell>
                <TableCell > Days </TableCell>
                <TableCell > Categories </TableCell>
                <TableCell > Created By </TableCell>
                <TableCell > Last Updated By </TableCell>
                <TableCell > Remarks </TableCell>
            </TableRow>
        </TableHead>
    )
}

const LinkSvEvents = ({assetInfoData}) => {
    const navTitleOffset = usePageTitleOffset('techSpecsNavCollapsed');

    const { enqueueSnackbar, closeSnackbar } = useSnackbar();
    const [isLoading, setLoading] = useState(false);
    const [skeletonLoader, setSkeletonLoader] = useState(false);
    const [bulkUnlink, setBulkUnLink] = useState({ modal: false,ids: [], title: '', type: '', data: null })
    const [svEventsInfo, setSvEventsInfo] = useState({ list: [], pagination: {} });
    const [linkingSvEvents, setLinkingSvEvents] = useState({ modal: false, data: null })
    const [circularLoader, setCircularloader] = useState(false)
    const [showMore, setShowMore] = useState({});

    useEffect(() => {
        trackActivity('Console Management', { page_title: 'Aircraft Technical Specification' , event_type: 'Maintenance Programs Tab Clicked' })
    }, [])

    useEffect(() => {
        if (!assetInfoData?.id) return;
        getSvEvents({ per_page: 50 }, "skeletonLoader" );
    }, [assetInfoData?.id, assetInfoData?.asset_type?.type])

    const getSvEvents = (query = {}, loaderType) => {
        
        loaderType === 'skeletonLoader' ? setSkeletonLoader(true) : setLoading(true)
        const url = `config-data/asset-sv-events/${assetTypeValues[assetInfoData?.asset_type?.type]?.urlType === 'lg' ? 'landing_gear' : assetTypeValues[assetInfoData?.asset_type?.type]?.urlType}/${assetInfoData?.id}/`
        globalGetService(url, query)
            .then(response => {
                if (checkApiStatus(response)) {
                    setSvEventsInfo(response.data.data)
                }
                loaderType === 'skeletonLoader' ? setSkeletonLoader(false) : setLoading(false)
            })
    }
    const linkUnlink = (type, ids) => {
        const idss = bulkUnlink?.type === 'bulk' || bulkUnlink?.type === 'single' ? bulkUnlink?.ids.map(item => item?.id) : [bulkUnlink?.data?.id]
        let payload;
        if (type === 'link') {
            payload = {
                sv_events: ids,
                action: 'link'
            };
        } else {
            payload = {
                sv_events: idss,
                action: 'unlink'
            };
        }

        const apiUrl = `/config-data/asset-sv-events/${assetTypeValues[assetInfoData?.asset_type?.type]?.urlType === 'lg' ? 'landing_gear' : assetTypeValues[assetInfoData?.asset_type?.type]?.urlType}/${assetInfoData?.id}/`;
        setCircularloader(true);
        globalPostService(apiUrl, payload)
            .then((response) => {
                if (checkApiStatus(response)) {
                    enqueueSnackbar(response?.data?.message, { variant: 'success', anchorOrigin: { vertical: 'top', horizontal: 'right' } });
                    setLinkingSvEvents({modal:false, data:null})
                    setBulkUnLink({ modal: false, ids: [] })
                    getSvEvents({per_page: svEventsInfo.pagination?.per_page,});
                    trackActivity('Console Management', { event_desc: type === 'link'? `Shop Visit Event Linked Successfully` : 'Shop Visit Event unLinked Successfully', page_title: 'Aircraft Technical Specification', event_type: type === 'link' ? 'Item Linked' : 'Item UnLinked', updated_id: type === 'link'? ids : idss || null, success_msg: response?.data?.message })
                } else {
                    enqueueSnackbar(response?.data?.message, { variant: 'error', anchorOrigin: { vertical: 'top', horizontal: 'right' } });
                    getSvEvents({per_page: svEventsInfo.pagination?.per_page,});
                    setLinkingSvEvents({modal:false, data:null})
                    setBulkUnLink({ modal: false, ids: [] })
                    trackActivity('Console Management', { event_desc: type === 'link'? 'Shop Visit Event Linking Failed' : 'Shop Visit Event Unlinking Failed', page_title: 'Aircraft Technical Specification', event_type: type === 'link' ? 'Item Linked' : 'Item UnLinked', updated_id: type === 'link'? ids : idss || null, error_msg: response?.data?.message })
                }
                setCircularloader(false);
            })
    }

    const toggleBulkOps = (flag, type, item) => { 
        if(type === 'bulk'){
            setBulkUnLink({...bulkUnlink, type : 'bulk', ids : flag ? item : [] })
        }else {
            setBulkUnLink({...bulkUnlink, type : 'single', ids : flag ? [...bulkUnlink.ids, item] : bulkUnlink.ids.filter(optionItem => optionItem.id !== item.id)})
        }
    }

    const toggleDescription = (field) => {
		setShowMore({
			...showMore,
			[field]: !showMore[field]
		})
	}
    
    return (
        <>
            {skeletonLoader ? <STableLoader count={6} size={7}/> :
                <div style={{ padding: "10px", height:`${(window.innerHeight-220) - navTitleOffset}px` }}>
                    <Paper className="console-paper" style={{ padding: '4px 8px' }}>
                        <Grid container spacing={1} alignItems="center">
                            <Grid item md={4}> </Grid>
                            <Grid item md={8}>
                                    <ul style={{ textAlign: "right" }}>
                                    {
                                        bulkUnlink?.type && bulkUnlink?.ids?.length ?
                                            <>
                                                <li className='list-inline-item'>
                                                    <Button onClick={() => setBulkUnLink({ modal: false, ids: [], title: '', type: '' })} size="small" variant="outlined" color="primary" >Cancel</Button>
                                                </li>
                                                <li className='list-inline-item'>
                                                    <Button onClick={() => setBulkUnLink({ ...bulkUnlink, title: 'Delete', modal: true })} variant="contained" size="small" color="secondary">{`UnLink (${bulkUnlink?.ids?.length})`}</Button>
                                                </li>
                                            </> : null
                                    }
                                        <li className='list-inline-item'>
                                            <Button onClick={() => setLinkingSvEvents({ modal: true, data:null})} color="primary" size='small' variant="contained">Link Shop Visit</Button>
                                        </li>
                                    </ul> 
                            </Grid>
                        </Grid>
                    </Paper>
                    <Paper>
                         <div style={{height:`${(window.innerHeight -  (svEventsInfo?.list?.length ? 330 : 280)) - navTitleOffset}px`,overflow:'auto', marginTop: "2px"}}>
                        <Table className="mui-table-format" stickyHeader>
                            <SvEventsHeader item={svEventsInfo?.list} toggleBulkOps={toggleBulkOps} bulkUnlink={bulkUnlink} />
                            <TableBody>
                                {svEventsInfo?.list?.length > 0 && svEventsInfo?.list?.map((item, index) =>
                                    <TableRow key={index} className={item?.deleted_at ? "grey-out" : ''}>
                                        <TableCell style={{ position: 'sticky', left: 0, backgroundColor: 'inherit', zIndex: 1, }}>
                                            <ul className="list-inline flex-centered" style={{ width: '130px' }}>
                                                <li className="list-inline-item hover-inline last-icon">
                                                    <Checkbox color="primary"  checked={bulkUnlink?.ids?.find(items => items?.id === item?.id) ? true : false}  onChange={(e) => {toggleBulkOps(e.target.checked, 'single', item)}} size="small" />
                                                </li>
                                                <li className="list-inline-item hover-inline" onClick={() => setBulkUnLink({ modal: true, data: item, ids:[] })}>
                                                    <Tooltip title='Unlink' arrow><DeleteOutline color="secondary" fontSize="small" /></Tooltip>
                                                </li>
                                            </ul>
                                        </TableCell>
                                        <TableCell><div style={{ width: '150px' }}>{item?.name || '--'}</div></TableCell>
                                        <TableCell><div style={{ width: '150px' }}>{item?.asset_type?.label || '--'}</div></TableCell>
                                        <TableCell><div style={{ width: '150px' }}>{numberWithCommas(item?.hours)}</div></TableCell>
                                        <TableCell><div style={{ width: '150px' }}>{numberWithCommas(item?.cycles)}</div></TableCell>
                                        <TableCell><div style={{ width: '150px' }}>{numberWithCommas(item?.months)}</div></TableCell>
                                        <TableCell><div style={{ width: '150px' }}>{numberWithCommas(item?.days)}</div></TableCell>
                                        <TableCell><div style={{ width: '150px' }}>{item?.category?.name || '--'}</div></TableCell>
                                        <TableCell>
                                            <div style={{ width: '150px' }}>
                                                {item?.created_by?.name || '--'}
                                                {item?.created_by?.name ?
                                                    <p style={{ fontSize: '11px', opacity: '0.8' }}>{moment(item?.created_at).format(displayDateFormat)}</p> : null
                                                }
                                            </div>
                                        </TableCell>
                                        <TableCell>
                                            <div style={{ width: '150px' }}>
                                                {item?.updated_by?.name || '--'}
                                                {item?.updated_by?.name ?
                                                    <p style={{ fontSize: '11px', opacity: '0.8' }}>{moment(item?.updated_at).format(displayDateFormat)}</p> : null
                                                }
                                            </div>
                                        </TableCell>
                                        <TableCell>
                                            {item?.remarks && item?.remarks?.length > 30 ? (
                                                <div style={{ width: '200px' }}>
                                                    {showMore[item?.field] ? (
                                                        <span>
                                                            <span dangerouslySetInnerHTML={{ __html: item?.remarks && item?.remarks.replace(/\n/g, '<br />') }} />
                                                            <a href="#" style={{ color: '#0E7FE1', fontSize: '12px' }} onClick={(e) => { e.preventDefault(); toggleDescription(item.field); }} > {" "}less </a>
                                                        </span>
                                                    ) : (
                                                        <span>
                                                            <span dangerouslySetInnerHTML={{ __html: item?.remarks && item?.remarks.substring(0, 25).replace(/\n/g, '<br />'), }} />
                                                            <a href="#" style={{ color: '#0E7FE1', fontSize: '12px' }} onClick={(e) => { e.preventDefault(); toggleDescription(item.field); }} > {" "}..more </a>
                                                        </span>
                                                    )}
                                                </div>
                                            ) : (
                                                <div dangerouslySetInnerHTML={{ __html: item?.remarks || '--', }} />
                                            )}
                                        </TableCell>
                                    </TableRow>
                                )}
                            </TableBody>
                        </Table>
                        {!svEventsInfo?.list?.length ? <div style={{ textAlign: 'center' }}><EmptyCollection title='No records found' /></div> : null}
                        </div>
                    </Paper>
                    <Paper square>
                        <Pagination
                            pagination={svEventsInfo?.pagination}
                            onChangePage={(event, newPage) => { getSvEvents({ page: newPage + 1, per_page: svEventsInfo.pagination?.per_page, }, 'pageLoader'); }}
                            onChangeRowsPerPage={(event) => getSvEvents({ page: 1, per_page: event.target.value, }, 'pageLoader')}
                        />
                    </Paper>
                </div>}
            {isLoading ? <PageLoader /> : null}
            <DeletePopUp
                confirmText={'UnLink'}
                modal={bulkUnlink.modal}
                title={bulkUnlink?.type === 'bulk' || bulkUnlink?.type === 'single' ? `Unlink Shop Visit Events (${bulkUnlink?.ids?.length})` : 'Unlink Shop Visit Events'}
                content={"Are you sure, you want to UnLink"}
                toggleModalFn={() => bulkUnlink.modal && setBulkUnLink({ modal: false, ids: [] })}
                deleteRecordFn={linkUnlink}
                circularloader={circularLoader}
            />
            {linkingSvEvents.modal &&
                <LinkingPopup
                  title="Shop Visit"
                  tableView
                  circularloader={circularLoader}
                  linkUnlink = {(type,ids)=>linkUnlink(type,ids)}
                  placeholder='Search By Shop Visit Events ...'
                  description='No Shop Visit Events is available to link'
                  url={`/config-data/asset-sv-events/${assetTypeValues[assetInfoData?.asset_type?.type]?.urlType === 'lg' ? 'landing_gear' : assetTypeValues[assetInfoData?.asset_type?.type]?.urlType}/${assetInfoData?.id}/?dropdown=True`}
                  toggleModalFn={() => setLinkingSvEvents({modal:false, data:null})}
                />
                } 
        </>
    )
}

export default withRouter(LinkSvEvents);